import React from "react";
import "./MissionBriefing.css";

const MissionBriefing = () => {
  return (
    <div className="mission-briefing">
      <div className="briefing-header">
        <h1>//ENCIPHERX 4.0 - CHALLENGE BRIEFING</h1>
      </div>

      <div className="rules-section">
        <h2>//rules and regulations</h2>

        <div className="rules-category">
          <h3>Instructions</h3>
          <ul className="rules-list">
            <li>
              <strong>Mandatory Laptop Requirement:</strong> All participants
              have to carry their respective laptops compulsorily.
            </li>
            <li>
              Participating teams are responsible for managing their
              participation alongside other events.
            </li>
            <li>
              The organizers will not be held accountable for any losses
              incurred.
            </li>
            <li>
              Participants must ensure the accuracy of their profile
              information, as the organizers will not be liable for any mistakes
              after certificate generation.
            </li>
          </ul>
        </div>

        <div className="rules-category">
          <h3>Operating System Requirement</h3>
          <ul className="rules-list">
            <li>
              Participants should have Linux OS (Kali Linux, Parrot OS, etc.)
              downloaded on their laptops, preferably in virtual machines (VMs).
            </li>
            <li>
              All EncipherX CTF teams will be provided with a website where the
              event will be hosted.
            </li>
            <li>
              EncipherX CTF participants will be provided with a VPN file to
              connect to the event machines.
            </li>
          </ul>
          <p className="note-text">
            <strong>Note:</strong> Please ensure to follow all provided
            instructions and updates for a smooth participation experience.
          </p>
        </div>

        <div className="rules-category">
          <h3>Eligibility for EncipherX CTF</h3>
          <p className="eligibility-text">
            The EncipherX CTF is open to all undergraduate and postgraduate
            professionals, making it an inclusive International event.
          </p>
        </div>

        <div className="rules-category">
          <h3>Rules for the Event</h3>
          <ol className="rules-list-numbered">
            <li>
              Teams participating in the CTF must refrain from conducting any
              attacks on the CTF infrastructure. This includes, but is not
              limited to, DoS, DDoS, bruteforcing, automated scans, or
              generating excessive traffic through any means on challenges or
              other contest infrastructure. Such activities are strictly
              prohibited and not intended in any question.
            </li>
            <li>
              Teams competing in offline mode are expected to maintain
              discipline within the college campus.
            </li>
            <li>
              Collaboration between different teams and sharing of flags is not
              allowed.
            </li>
            <li>
              Participants/Teams are strictly prohibited from publishing
              solutions during the event on platforms such as blogs, GitHub,
              YouTube, etc.
            </li>
            <li>
              Any participants/Teams found violating the aforementioned rules
              will be disqualified from the contest, and strict action will be
              taken.
            </li>
            <li>
              Team EncipherX reserves the right to introduce new rules or modify
              existing rules during or after the contest. These rules will apply
              to all participants in the contest.
            </li>
            <li>The decisions made by Team EncipherX will be final.</li>
            <li>
              By participating in the contest, you acknowledge that you have
              read and fully agree to adhere to the above rules.
            </li>
            <li>
              While participants are allowed to use tools, references, and
              snippets publicly available on the Internet, seeking help from
              people, forums, etc., for solving a challenge is strictly
              prohibited.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default MissionBriefing;
